import React, { useState, useEffect } from "react";

import { Card, CardContent, CardHeader } from "./ui/card";
import { Dialog, DialogTrigger, DialogContent, DialogClose } from "./ui/dialog";
import home from "../assets/images/homeIcon.svg";
import CurrencyFormatter from "../utils/currencyFormatter";
import prod1 from "../assets/images/imageProd.png";
import {
  Bath,
  Bed,
  ChevronDown,
  MapPin,
  CarFront,
  Eye,
  X,
  Loader,
  CircleCheck,
  ArrowLeft,
  Grid2X2,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  useInvestProduct,
  useExistingApplication,
  useAllOwnedAssets,
  useWalletBalance,
} from "../hooks/query/queries";
import gallery1 from "../assets/images/gal1.jpg";
import InvestPropertyGalleryCarousel from "./InvestPropertyGalleryCarousel";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";
import InvestApplyStepOne from "./InvestApplyStepOne";
import InvestQuestionaire from "./InvestQuestionaire";
import InvestTermsAndConditions from "./InvestTermsAndConditions";
import InvestStepTwo from "./InvestStepTwo";
import InvestFaq from "./InvestFaq";
import { createInvestmentApplication } from "../services/investService";
import InvestComplete from "./InvestComplete";
import PlainTextViewer from "./TextFormatter";
import { FormattedDate } from "../utils/dateFormatter";
import StringFormatter from "../utils/stringFormatter";
export default function InvestProperty({ productId, onBack }) {
  const { data: investProduct } = useInvestProduct(productId);
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  const [currentStep, setCurrentStep] = useState(0);
  const [openSeeMore, setOpenSeeMore] = useState(false);
  const [openSeeMoreSecondary, setOpenSeeMoreSecondary] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState(null);
  const [index, setIndex] = useState(null);
  const [parentCurrentAmount, setParentCurrentAmount] = useState(null);
  const [showDone, setShowDone] = useState(false);
  const [questionnaireAnswers, setQuestionnaireAnswers] = useState(null);
  const [loading, setLoading] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);

  const { data: assetsOwned, isLoading } = useAllOwnedAssets();

  const { data: existingApp } = useExistingApplication(
    userProfile?._id,
    productId
  );

  const { data: zarAmount, isLoading: loadingAmount } = useWalletBalance();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const DateFormatter = new FormattedDate();

  const assetId = investProduct?.assetId?._id;
  const assetType = investProduct?.assetId?.asset;
  const fiat = zarAmount?.assetBalances?.fiat?.zar;
  const asset = investProduct?.assetId?.asset;
  const depositType = investProduct?.depositFee?.feeType;
  const withdrawalType = investProduct?.withdrawalFee?.feeType;
  // const withdrawalFee = investProduct?.withdrawalFee?.feeAmount?.$numberDecimal;
  // const depositFee = investProduct?.depositFee?.feeAmount?.$numberDecimal;
  const withdrawalFee = 0;
  const depositFee = 0;

  useEffect(() => {
    const selectAsset = () => {
      if (assetType === "zar") {
        setSelectedAsset(fiat);
      }
      if (assetType !== "zar") {
        const assetSelected = assetsOwned?.find(
          (asset) => asset.assetId === assetId
        );
        setSelectedAsset(assetSelected);
      }
    };
    selectAsset();
  }, [zarAmount, assetsOwned, assetType, assetId, fiat]);

  const userDetails = {
    name: userProfile?.personal_info?.name,
    surname: userProfile?.personal_info?.lastname,
    cellphone: userProfile?.personal_info?.phoneNumber,
    email: userProfile?.email,
  };
  const formatter = new CurrencyFormatter();
  const OPTIONS = { loop: true };
  const slides =
    investProduct?.imageUrls?.length > 0 ? investProduct.imageUrls : gallery1;
  const minAmount = investProduct?.minDeposit?.$numberDecimal;
  const maxAmount = investProduct?.maxDeposit?.$numberDecimal;
  const [bgImage, setBgImage] = useState(slides[index]);

  const toggleAccordionSeeMore = () => setOpenSeeMore((prev) => !prev);

  useEffect(() => {
    const delay = setTimeout(() => {
      setBgImage(slides[index]);
    }, 600);

    return () => clearTimeout(delay);
  }, [index, slides]);

  const toggleAccordionSecond = () => {
    setOpenSeeMoreSecondary((prev) => !prev);
  };

  const startApplication = () => {
    setOpenDialog(true);
  };

  const onFinish = (values) => {};

  const applicationData = {
    productId: investProduct?._id,
    userId: userProfile?._id,
    status: "pending",
    investmentAmount: parentCurrentAmount,
    experience: questionnaireAnswers?.[0],
    riskTolerance: questionnaireAnswers?.[1],
    primaryGoal: questionnaireAnswers?.[2],
    investmentPeriod: questionnaireAnswers?.[3],
    concerns: questionnaireAnswers?.[4],
    termAndConditon1: termsAndConditions?.[0],
    termAndConditon2: termsAndConditions?.[1],
    termAndConditon3: termsAndConditions?.[2],
  };

  const handleArray = (tsAndCs) => {
    setTermsAndConditions(tsAndCs);
    setLoading(true);
    handleSubmit();
  };

  const next = async (answers) => {
    try {
      setCurrentStep((prev) => prev + 1);
      if (answers) {
        setQuestionnaireAnswers(answers);
      }
    } catch (error) {}
  };
  const steps = [
    {
      title: "Confirm Details",
      content: (
        <InvestApplyStepOne
          initialValues={userDetails}
          onFinish={onFinish}
          onNext={next}
        />
      ),
    },
    {
      title: "Amount",
      content: (
        <InvestStepTwo
          productId={investProduct?._id}
          selectedAsset={selectedAsset}
          assetsOwned={assetsOwned}
          loadingAmount={loadingAmount}
          setSelectedAsset={setSelectedAsset}
          assetId={assetId}
          isLoading={isLoading}
          setParentCurrentAmount={setParentCurrentAmount}
          parentCurrentAmount={parentCurrentAmount}
          showGraph={false}
          onNext={next}
          amountYearly={investProduct?.amountForEachYearOrMonth}
          durationYearly={investProduct?.durationInYearOrMonth}
          minAmount={minAmount}
          maxAmount={maxAmount}
        />
      ),
    },
    {
      title: "Questionaire",
      content: <InvestQuestionaire onComplete={next} />,
    },
    {
      title: "Terms and Conditions",
      content: (
        <InvestTermsAndConditions onComplete={handleArray} loading={loading} />
      ),
    },
  ];

  const prev = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };

  const done = () => {
    setOpenDialog(false);
  };
  const handleShowTerms = () => {
    setTermsOpen(true);
  };

  const handleSubmit = async () => {
    try {
      const results = await createInvestmentApplication(applicationData);

      setShowDone(true);
      return results;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const totalSteps = steps.length;
  const progress = (currentStep / (totalSteps - 1)) * 100;

  const string = new StringFormatter();

  return (
    <div className="col-span-4">
      <div className="py-3 mb-2">
        <Card>
          <CardHeader>
            <div className="flex justify-between items-center">
              <div className="flex gap-3">
                <div>
                  <img src={home} alt="house icon" className="w-20 h-20" />
                </div>
                <div>
                  <h2 className="font-bold text-3xl text-gray-800">
                    {investProduct?.name}
                  </h2>
                  {investProduct?.moreDetails && (
                    <p className="flex items-center text-gray-700 mt-1">
                      <MapPin className="w-4 h-4" />
                      {investProduct?.moreDetails?.location}
                    </p>
                  )}
                  <p className="mt-4 text-gray-600">
                    {investProduct?.description}
                  </p>
                </div>
              </div>
              {investProduct?.status === "pending" ? (
                <div className="flex self-start gap-2 bg-yellow-200 text-yellow-700 px-3 py-1 rounded-full">
                  <Loader />
                  {investProduct?.status.charAt(0).toUpperCase() +
                    investProduct?.status.slice(1)}
                </div>
              ) : investProduct?.status === "active" ? (
                <div className="flex self-start gap-2 bg-emerald-200 text-emerald-700 px-3 py-1 rounded-full">
                  <CircleCheck />
                  {investProduct?.status.charAt(0).toUpperCase() +
                    investProduct?.status.slice(1)}
                </div>
              ) : (
                <div className="flex self-start gap-2 bg-purple-200 text-purple-700 px-3 py-1 rounded-full">
                  <Loader />
                  Coming Soon
                </div>
              )}
            </div>
          </CardHeader>
          <CardContent>
            <Dialog>
              <div className="relative group rounded-3xl overflow-hidden h-96">
                <img
                  src={
                    investProduct?.imageUrls.length > 0
                      ? investProduct?.imageUrls[0]
                      : prod1
                  }
                  alt="flats"
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />

                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <DialogTrigger asChild>
                    <button className="w-14 h-14 rounded-full border-2 border-white flex items-center justify-center hover:bg-white/10 transition">
                      <Eye className="text-white w-6 h-6" />
                    </button>
                  </DialogTrigger>
                </div>
              </div>

              <DialogContent className="!rounded-none bg-black/70  backdrop-blur-md p-0 m-0 border-none shadow-none max-w-screen h-screen flex flex-col z-50">
                <div className="absolute inset-0 z-0 transition-opacity duration-700 ease-in-out">
                  <img
                    key={index}
                    src={bgImage}
                    alt="Backdrop"
                    className="w-full h-full object-cover blur-2xl opacity-30 transition-all duration-700 ease-in-out"
                  />
                  <div className="absolute inset-0 bg-black/10"></div>
                </div>
                <div className="relative z-10 w-full h-full flex flex-col justify-between">
                  <div className="relative w-full flex items-center justify-center py-6">
                    <h2 className="text-white text-2xl font-semibold">
                      Gallery
                    </h2>

                    <DialogClose>
                      <Button
                        variant="ghost"
                        className="w-10 h-10 absolute top-4 right-4 text-gray-400 hover:text-gray-600 rounded-full p-0 flex items-center justify-center border border-gray-200 hover:bg-gray-100"
                      >
                        <X size={18} className="text-white" />
                      </Button>
                    </DialogClose>
                  </div>

                  <div className="w-full h-px bg-white/10 mb-4" />

                  <div className="flex-1 w-full flex items-center justify-center ">
                    <InvestPropertyGalleryCarousel
                      slides={slides}
                      options={OPTIONS}
                      navClass="carousel-two"
                      setIndex={setIndex}
                    />
                  </div>
                </div>
              </DialogContent>
            </Dialog>

            <p className="mt-5 mb-1 font-bold text-gray-500">
              Investment Details
            </p>
            <div className="border rounded-lg divide-y">
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">Value</span>
                <span className="text-sm font-medium text-gray-800">
                  {formatter.format(
                    investProduct?.value?.$numberDecimal,
                    investProduct?.assetId?.asset?.toUpperCase()
                  )}
                </span>
              </div>
              {/* <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">Income</span>
                <span className="text-sm font-medium text-gray-800">
                  {formatter.format(
                    investProduct?.income?.$numberDecimal,
                    investProduct?.assetId?.asset?.toUpperCase()
                  )}
                </span>
              </div> */}
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">ROI</span>
                <span className="text-sm font-medium text-gray-800">
                  {investProduct?.roi?.$numberDecimal} %
                </span>
              </div>

              {openSeeMore && (
                <>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">Asset</span>
                    <span className="text-sm font-medium text-gray-800">
                      {investProduct?.assetId?.asset?.toUpperCase()}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Investment Term
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {investProduct?.duration?.period}{" "}
                      {string.capitalizeFirst(investProduct?.duration?.unit)}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Investment Type
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {string.capitalizeFirst(
                        investProduct?.investmentType?.toUpperCase()
                      )}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Minimum Investment
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {formatter.format(
                        investProduct?.minDeposit?.$numberDecimal,
                        investProduct?.assetId?.asset?.toUpperCase()
                      )}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Maximum Investment
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {formatter.format(
                        investProduct?.maxDeposit?.$numberDecimal,
                        investProduct?.assetId?.asset?.toUpperCase()
                      )}
                    </span>
                  </div>
                  {/* <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Deposit Fee Type
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {string.capitalizeFirst(depositType)}
                    </span>
                  </div> */}
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Deposit Fee Amount
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {depositType === "fixed"
                        ? formatter.format(depositFee, asset?.toUpperCase())
                        : depositFee + "%"}
                    </span>
                  </div>
                  {/* <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Withdrawal Fee Type
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {string.capitalizeFirst(withdrawalType)}
                    </span>
                  </div> */}
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Withdrawal Fee Amount
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {withdrawalType === "fixed"
                        ? formatter.format(withdrawalFee, asset?.toUpperCase())
                        : withdrawalFee + "%"}
                      {}{" "}
                    </span>
                  </div>
                  {/* <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Profit Amount for{" "}
                      {investProduct?.durationInYearOrMonth?.[0]}
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {formatter.format(
                        investProduct?.amountForEachYearOrMonth?.[0],
                        investProduct?.assetId?.asset?.toUpperCase()
                      )}
                    </span>
                  </div> */}
                  {/* <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Profit Amount for{" "}
                      {investProduct?.durationInYearOrMonth?.[1]}
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {formatter.format(
                        investProduct?.amountForEachYearOrMonth?.[1],
                        investProduct?.assetId?.asset?.toUpperCase()
                      )}
                    </span>
                  </div> */}
                </>
              )}

              <div className="p-4">
                <div
                  onClick={toggleAccordionSeeMore}
                  className="flex justify-between cursor-pointer items-center"
                >
                  <span className="text-sm text-gray-700">
                    {openSeeMore ? "See Less" : "See More"}
                  </span>
                  <span
                    className="text-sm font-medium text-gray-600 transition-transform"
                    style={{
                      transform: openSeeMore
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    <ChevronDown />
                  </span>
                </div>
              </div>
            </div>
            {investProduct?.moreDetails && (
              <>
                <p className="mt-5 mb-1 font-bold text-gray-500">
                  Property Details
                </p>
                <div className="border rounded-lg divide-y">
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700 flex gap-1 items-center">
                      <Bed className="w-4 h-4" /> Bedrooms
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {investProduct?.moreDetails?.bedrooms}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700 flex gap-1 items-center">
                      <Bath className="w-4 h-4" /> Bathrooms
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {investProduct?.moreDetails?.bathrooms}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700 flex gap-1 items-center">
                      <CarFront className="w-4 h-4" /> Parking
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {investProduct?.moreDetails?.parking}
                    </span>
                  </div>
                  {openSeeMoreSecondary && (
                    <>
                      <div className="p-4 flex justify-between">
                        <span className="text-sm text-gray-700 flex gap-1 items-cente">
                          <Grid2X2 className="w-4 h-4" /> Area
                        </span>
                        <span className="text-sm font-medium text-gray-800">
                          {investProduct?.moreDetails?.area}m2
                        </span>
                      </div>
                    </>
                  )}
                  <div className="p-4">
                    <div
                      onClick={toggleAccordionSecond}
                      className="flex justify-between cursor-pointer items-center"
                    >
                      <span className="text-sm text-gray-700">
                        {openSeeMoreSecondary ? "See Less" : "See More"}
                      </span>
                      <span
                        className="text-sm font-medium text-gray-600 transition-transform"
                        style={{
                          transform: openSeeMore
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      >
                        <ChevronDown />
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="flex justify-between items-center mt-8 gap-8">
              <div className="">
                <button
                  onClick={() => {
                    onBack?.();
                  }}
                  variant="ghost"
                  className="p-8 w-full flex items-center justify-between rounded-none"
                >
                  <div className="border p-2 rounded-full bg-transparent">
                    <ArrowLeft className="h-4 w-4 transition-transform hover:translate-x-1" />
                  </div>
                </button>
              </div>
              <div className="flex items-center gap-5">
                <button
                  onClick={handleShowTerms}
                  className="text-rose-500 hover:underline focus:outline-none"
                >
                  Terms and Conditions
                </button>

                {investProduct?.status === "active" && !existingApp ? (
                  <button
                    onClick={() => {
                      startApplication();
                    }}
                    className="py-3 px-24 text-sm font-bold text-white rounded-full bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90"
                  >
                    Apply Now
                  </button>
                ) : existingApp?.exists === true ? (
                  <Button
                    disabled={false}
                    onClick={() => {
                      navigate("/invest/product", {
                        state: {
                          productType: "asset2",
                          productId: investProduct?._id,
                          ledgerId: existingApp?.ledgerId,

                          applicationId: existingApp?.applicationId,
                        },
                      });
                    }}
                    className="py-3 px-24 text-sm font-bold text-white rounded-full bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90"
                  >
                    View Details
                  </Button>
                ) : (
                  <div></div>
                )}
              </div>
              <div className=""></div>
            </div>
            <Dialog open={openDialog} onOpenChange={setOpenDialog}>
              <DialogContent
                currentStep={currentStep}
                goBack={prev}
                className="!rounded-none bg-white p-0 m-0 border-none shadow-none max-w-screen h-screen flex flex-col z-50"
              >
                <div className="relative z-10 w-full h-full flex flex-col justify-between">
                  <div className="relative w-full flex items-center justify-center py-6">
                    {!showDone && currentStep !== 0 && (
                      <Button
                        onClick={prev}
                        variant="ghost"
                        className="w-10 h-10 absolute top-4 left-4 text-gray-400 hover:text-gray-600 rounded-full p-0 flex items-center justify-center border text-gray-400 hover:bg-gray-100"
                      >
                        <ArrowLeft size={18} className="text-gray-500" />
                      </Button>
                    )}
                    <h2 className="text-brand-primary text-2xl font-semibold">
                      {investProduct?.name}
                    </h2>

                    <DialogClose>
                      <Button
                        variant="ghost"
                        className="w-10 h-10 absolute top-4 right-4 text-gray-400 hover:text-gray-600 rounded-full p-0 flex items-center justify-center border text-gray-400 hover:bg-gray-100"
                      >
                        <X size={18} className="text-gray-500" />
                      </Button>
                    </DialogClose>
                  </div>

                  <div className="w-full h-px bg-black/10 mb-4" />

                  {!showDone && (
                    <div className="flex-1 w-full flex text-black items-center justify-center px-6 pb-4 space-y-6 flex-col">
                      <div className="w-full max-w-md mb-10">
                        <div className="relative h-2 w-full bg-gray-300 rounded-full">
                          <div
                            className="absolute top-0 left-0 h-2 bg-gradient-to-r from-brand-secondary to-accent-magenta rounded-full transition-all duration-300 z-0"
                            style={{ width: `${progress}%` }}
                            aria-hidden="true"
                          />
                          <div className="absolute top-0 left-0 w-full h-2 flex justify-between z-10">
                            {steps.map((step, index) => (
                              <div
                                key={index}
                                className="relative flex flex-col items-center"
                              >
                                <div className="mt-2 text-sm font-semibold text-gray-600">
                                  {step.title}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="w-full max-w-md mx-auto mb-6 mt-10">
                        {steps[currentStep].content}
                      </div>
                      <div className="mt-6 flex flex-col items-center space-y-4 w-full max-w-md">
                        {/* {currentStep === steps.length - 1 && (
                         
                        )} */}
                      </div>
                    </div>
                  )}
                  {showDone && (
                    <div className="flex-1 w-full flex text-black items-center justify-center px-6 pb-4 space-y-6 flex-col">
                      <InvestComplete onDone={done} />
                    </div>
                  )}
                </div>
              </DialogContent>
            </Dialog>
            <Dialog open={termsOpen} onOpenChange={setTermsOpen}>
              <DialogContent className="!rounded-none bg-white p-0 m-0 border-none shadow-none max-w-screen h-screen flex flex-col z-50">
                <div className="relative z-10 w-full h-full flex flex-col justify-between">
                  <div className="relative w-full flex items-center justify-center py-6">
                    <h2 className="text-brand-primary text-2xl font-semibold">
                      Terms & Conditions
                    </h2>

                    <DialogClose>
                      <Button
                        variant="ghost"
                        className="w-10 h-10 absolute top-4 right-4 text-gray-400 hover:text-gray-600 rounded-full p-0 flex items-center justify-center border text-gray-400 hover:bg-gray-100"
                      >
                        <X size={18} className="text-gray-500" />
                      </Button>
                    </DialogClose>
                  </div>

                  <div className="w-full h-px bg-black/10 mb-4" />

                  <div className="flex-1  flex flex-col items-center justify-start mt-24 px-6 pb-4 space-y-6 text-left">
                    {/* Section Heading */}
                    <div className="w-full max-w-[1000px]">
                      <div className="mb-12">
                        <h2 className="text-brand-primary text-4xl font-normal">
                          General Terms
                        </h2>
                        <p className="text-[14px] text-text-secondary font-normal mt-1">
                          Last updated:
                          {DateFormatter.simpleFormat(
                            investProduct?.termsAndConditions?.createdAt
                          )}
                        </p>
                      </div>

                      {/* Section Content */}
                      <div className="text-left max-h-96 overflow-y-auto p-4 border rounded-md">
                        <h3 className="text-brand-primary text-base font-semibold mb-4">
                          Agreement to Terms
                        </h3>
                        <PlainTextViewer
                          value={
                            investProduct?.termsAndConditions?.content || ""
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </DialogContent>
            </Dialog>
          </CardContent>
        </Card>
      </div>
      <InvestFaq faqs={investProduct?.faqs} />
    </div>
  );
}
